"use strict";
// Do not edit directly
// Generated on Thu, 14 Dec 2023 00:00:52 GMT
exports.__esModule = true;
exports["default"] = {
    "color": {
        "blue": {
            "100": [
                {
                    "value": "#e0f2ff",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#E0F2FF"
                    },
                    "name": "colorBlue100",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "blue",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#b5deff",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#B5DEFF"
                    },
                    "name": "colorBlue200",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "blue",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#78bbfa",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#78BBFA"
                    },
                    "name": "colorBlue300",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "blue",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#3892f3",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#3892F3"
                    },
                    "name": "colorBlue400",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "blue",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#0265dc",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#0265DC"
                    },
                    "name": "colorBlue500",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "blue",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#004491",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#004491"
                    },
                    "name": "colorBlue600",
                    "attributes": {
                        "category": "color",
                        "type": "blue",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "blue",
                        "600"
                    ]
                }
            ]
        },
        "neutral": {
            "0": [
                {
                    "value": "#ffffff",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffffff"
                    },
                    "name": "colorNeutral0",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "0"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "0"
                    ]
                }
            ],
            "10": [
                {
                    "value": "#fcfcfc",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fcfcfc"
                    },
                    "name": "colorNeutral10",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "10"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "10"
                    ]
                }
            ],
            "20": [
                {
                    "value": "#fafafa",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fafafa"
                    },
                    "name": "colorNeutral20",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "20"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "20"
                    ]
                }
            ],
            "30": [
                {
                    "value": "#f7f7f7",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#f7f7f7"
                    },
                    "name": "colorNeutral30",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "30"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "30"
                    ]
                }
            ],
            "40": [
                {
                    "value": "#f5f5f5",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#f5f5f5"
                    },
                    "name": "colorNeutral40",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "40"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "40"
                    ]
                }
            ],
            "50": [
                {
                    "value": "#eeeeee",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#eeeeee"
                    },
                    "name": "colorNeutral50",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "50"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "50"
                    ]
                }
            ],
            "60": [
                {
                    "value": "#dfe0e1",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#dfe0e1"
                    },
                    "name": "colorNeutral60",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "60"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "60"
                    ]
                }
            ],
            "70": [
                {
                    "value": "#bcbcbd",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#bcbcbd"
                    },
                    "name": "colorNeutral70",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "70"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "70"
                    ]
                }
            ],
            "80": [
                {
                    "value": "#949596",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#949596"
                    },
                    "name": "colorNeutral80",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "80"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "80"
                    ]
                }
            ],
            "90": [
                {
                    "value": "#737475",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#737475"
                    },
                    "name": "colorNeutral90",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "90"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "90"
                    ]
                }
            ],
            "100": [
                {
                    "value": "#606162",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#606162"
                    },
                    "name": "colorNeutral100",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#444445",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#444445"
                    },
                    "name": "colorNeutral200",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#2d2e31",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#2d2e31"
                    },
                    "name": "colorNeutral300",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#141414",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#141414"
                    },
                    "name": "colorNeutral400",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#040404",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#040404"
                    },
                    "name": "colorNeutral500",
                    "attributes": {
                        "category": "color",
                        "type": "neutral",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "neutral",
                        "500"
                    ]
                }
            ]
        },
        "blue-grey": {
            "100": [
                {
                    "value": "#eaeff2",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#eaeff2"
                    },
                    "name": "colorBlueGrey100",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#d0d8dd",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#d0d8dd"
                    },
                    "name": "colorBlueGrey200",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#b4c1c8",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#b4c1c8"
                    },
                    "name": "colorBlueGrey300",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#8c9ca5",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#8c9ca5"
                    },
                    "name": "colorBlueGrey400",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#6a7a85",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#6a7a85"
                    },
                    "name": "colorBlueGrey500",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#576671",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#576671"
                    },
                    "name": "colorBlueGrey600",
                    "attributes": {
                        "category": "color",
                        "type": "blue-grey",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "blue-grey",
                        "600"
                    ]
                }
            ]
        },
        "orange": {
            "100": [
                {
                    "value": "#ffeccc",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffeccc"
                    },
                    "name": "colorOrange100",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "orange",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#fdd291",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fdd291"
                    },
                    "name": "colorOrange200",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "orange",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#ffa037",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffa037"
                    },
                    "name": "colorOrange300",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "orange",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#e46f00",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#e46f00"
                    },
                    "name": "colorOrange400",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "orange",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#b14c00",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#b14c00"
                    },
                    "name": "colorOrange500",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "orange",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#7a2f00",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#7a2f00"
                    },
                    "name": "colorOrange600",
                    "attributes": {
                        "category": "color",
                        "type": "orange",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "orange",
                        "600"
                    ]
                }
            ]
        },
        "yellow": {
            "100": [
                {
                    "value": "#fff9e2",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fff9e2"
                    },
                    "name": "colorYellow100",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#fff0b1",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fff0b1"
                    },
                    "name": "colorYellow200",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#ffe278",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffe278"
                    },
                    "name": "colorYellow300",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#ffc902",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffc902"
                    },
                    "name": "colorYellow400",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#ffbe00",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffbe00"
                    },
                    "name": "colorYellow500",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#de9500",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#de9500"
                    },
                    "name": "colorYellow600",
                    "attributes": {
                        "category": "color",
                        "type": "yellow",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "yellow",
                        "600"
                    ]
                }
            ]
        },
        "green": {
            "100": [
                {
                    "value": "#cef8e0",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#CEF8E0"
                    },
                    "name": "colorGreen100",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "green",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#89ecbc",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#89ECBC"
                    },
                    "name": "colorGreen200",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "green",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#49cc93",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#49CC93"
                    },
                    "name": "colorGreen300",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "green",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#15a46e",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#15A46E"
                    },
                    "name": "colorGreen400",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "green",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#007a4d",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#007A4D"
                    },
                    "name": "colorGreen500",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "green",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#005132",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#005132"
                    },
                    "name": "colorGreen600",
                    "attributes": {
                        "category": "color",
                        "type": "green",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "green",
                        "600"
                    ]
                }
            ]
        },
        "cyan": {
            "100": [
                {
                    "value": "#e3fcff",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#e3fcff"
                    },
                    "name": "colorCyan100",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#b1f3fa",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#b1f3fa"
                    },
                    "name": "colorCyan200",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#13ceea",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#13ceea"
                    },
                    "name": "colorCyan300",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#08bfdf",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#08bfdf"
                    },
                    "name": "colorCyan400",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#0ca5c0",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#0ca5c0"
                    },
                    "name": "colorCyan500",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#038299",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#038299"
                    },
                    "name": "colorCyan600",
                    "attributes": {
                        "category": "color",
                        "type": "cyan",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "cyan",
                        "600"
                    ]
                }
            ]
        },
        "purple": {
            "100": [
                {
                    "value": "#f1edff",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#f1edff"
                    },
                    "name": "colorPurple100",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "purple",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#c1b6f2",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#c1b6f2"
                    },
                    "name": "colorPurple200",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "purple",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#8772e5",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#8772e5"
                    },
                    "name": "colorPurple300",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "purple",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#6954c0",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#6954c0"
                    },
                    "name": "colorPurple400",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "purple",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#4f3a9e",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#4f3a9e"
                    },
                    "name": "colorPurple500",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "purple",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#422799",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#422799"
                    },
                    "name": "colorPurple600",
                    "attributes": {
                        "category": "color",
                        "type": "purple",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "purple",
                        "600"
                    ]
                }
            ]
        },
        "red": {
            "100": [
                {
                    "value": "#ffece9",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffece9"
                    },
                    "name": "colorRed100",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "red",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#ffb2a0",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ffb2a0"
                    },
                    "name": "colorRed200",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "red",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#ff745f",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#ff745f"
                    },
                    "name": "colorRed300",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "red",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#f94d32",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#f94d32"
                    },
                    "name": "colorRed400",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "red",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#e13212",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#e13212"
                    },
                    "name": "colorRed500",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "red",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#bf2a00",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#bf2a00"
                    },
                    "name": "colorRed600",
                    "attributes": {
                        "category": "color",
                        "type": "red",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "red",
                        "600"
                    ]
                }
            ]
        },
        "magenta": {
            "100": [
                {
                    "value": "#fbeaf5",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#fbeaf5"
                    },
                    "name": "colorMagenta100",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "100"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "100"
                    ]
                }
            ],
            "200": [
                {
                    "value": "#faafe2",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#faafe2"
                    },
                    "name": "colorMagenta200",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "200"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "200"
                    ]
                }
            ],
            "300": [
                {
                    "value": "#d949a9",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#d949a9"
                    },
                    "name": "colorMagenta300",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "300"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "300"
                    ]
                }
            ],
            "400": [
                {
                    "value": "#b52d88",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#b52d88"
                    },
                    "name": "colorMagenta400",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "400"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "400"
                    ]
                }
            ],
            "500": [
                {
                    "value": "#982071",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#982071"
                    },
                    "name": "colorMagenta500",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "500"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "500"
                    ]
                }
            ],
            "600": [
                {
                    "value": "#7d165b",
                    "filePath": "tokens/themes/core/color.js",
                    "isSource": true,
                    "original": {
                        "value": "#7d165b"
                    },
                    "name": "colorMagenta600",
                    "attributes": {
                        "category": "color",
                        "type": "magenta",
                        "item": "600"
                    },
                    "path": [
                        "color",
                        "magenta",
                        "600"
                    ]
                }
            ]
        }
    }
};
